import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from "@emotion/styled";
import { ArrowDownIcon } from "@smartsheet/lodestar-icons";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import { ChevronDownIcon } from "@smartsheet/ursa-icons";
import React from "react";
import { selectV2Theme } from "../selectV2Theme";
var ToggleButtonLodestar = styled(ArrowDownIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    // Make this a bit smaller to account for the shared styles from ActionButton.\n    position: relative;\n    top: -2px;\n    left: -2px;\n"])));
var ToggleButtonWrapper = styled("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    // Make this a bit smaller to account for the shared styles from ActionButton.\n    // margin: -4px;\n    height: ", ";\n    width: ", ";\n"])), function (_ref) {
  var themeMode = _ref.themeMode;
  return selectV2Theme.actionButtons.buttonWrapperSize(themeMode);
}, function (_ref2) {
  var themeMode = _ref2.themeMode;
  return selectV2Theme.actionButtons.buttonWrapperSize(themeMode);
});
export var ToggleButtonIcon = function ToggleButtonIcon() {
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(ToggleButtonWrapper, {
    themeMode: themeMode
  }, function () {
    switch (themeMode) {
      case "ursa-light":
        return /*#__PURE__*/React.createElement(ChevronDownIcon, {
          size: 16
        });
      case "lodestar-light":
      case "oldestar":
        return /*#__PURE__*/React.createElement(ToggleButtonLodestar, null);
    }
  }());
};
//# sourceMappingURL=ToggleButtonIcon.js.map